'use strict';

var ThemeUtils = {};

ThemeUtils.toggle_slimscroll = function (item) {
    if ($('#wrapper').hasClass('enlarged')) {
        $(item).css('overflow', 'inherit').parent().css('overflow', 'inherit');
        $(item).siblings('.slimScrollBar').css('visibility', 'hidden');
    } else {
        $(item).css('overflow', 'hidden').parent().css('overflow', 'hidden');
        $(item).siblings('.slimScrollBar').css('visibility', 'visible');
    }
};

ThemeUtils.closeSearch = function () {
    $('#app').find('#mobile-search-bar').removeClass('in');
};

module.exports = ThemeUtils;
